import { render, staticRenderFns } from "./user_flow.vue?vue&type=template&id=040d4b35&scoped=true"
import script from "./user_flow.vue?vue&type=script&lang=js"
export * from "./user_flow.vue?vue&type=script&lang=js"
import style0 from "./user_flow.vue?vue&type=style&index=0&id=040d4b35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d4b35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
